import { Chip } from '@coolblue-development/freddy';
import { Award } from '@coolblue-development/icons';
import { SearchVacancyItemOption } from '@server/careers-backend/search';
import { EducationLevel } from '@sharedTypes';

type Props = {
  educationLevels: SearchVacancyItemOption[];
};

export const EducationChip = ({ educationLevels }: Props) => {
  if (
    educationLevels.length === 0 ||
    educationLevels.some(level => level.id === EducationLevel.None)
  ) {
    return null;
  }
  return (
    <Chip startIcon={<Award />}>{educationLevels.map(level => level.displayName).join(' / ')}</Chip>
  );
};
